import React from 'react';
import clsx from 'clsx';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import Input from '../../../components/input';
import Button from '../../../components/button';
import Image from '../../../components/image';
import Label from '../../../components/label';
import FacebookButton from '../../../components/facebook';
import GoogleButton from '../../../components/google';
import OutsideButton from '../../../components/outside';
import styles from './view.scss';

function View(props) {
  const {
    t,
    i18n,
    inputValue,
    allowEmail,
    allowPhone,
    countryCode,
    showCountryCode,
    errorText,
    presenter,
    disableCountryPicker,
    loading,
    showFacebook,
    showGoogle,
    showOutsideOauth,
    oauthOnly,
  } = props;
  let label = null;
  let placeholder = null;
  let type = 'text';
  if (allowEmail && allowPhone) {
    label =
      i18next.exists('login.landing.input_label_email_phone') &&
      t('login.landing.input_label_email_phone');
    placeholder =
      i18next.exists('login.landing.input_placeholder_email_phone') &&
      t('login.landing.input_placeholder_email_phone');
  } else if (allowEmail) {
    label =
      i18next.exists('login.landing.input_label_email') && t('login.landing.input_label_email');
    placeholder =
      i18next.exists('login.landing.input_placeholder_email') &&
      t('login.landing.input_placeholder_email');
    type = 'email';
  } else if (allowPhone) {
    label =
      i18next.exists('login.landing.input_label_phone') && t('login.landing.input_label_phone');
    placeholder =
      i18next.exists('login.landing.input_placeholder_phone') &&
      t('login.landing.input_placeholder_phone');
    type = 'tel';
  }

  return (
    <div className={clsx('login-landing-container', styles.container)}>
      <div className={clsx('login-landing-background-image-container', styles.imageContainer)}>
        <Image
          alt=""
          src={
            i18n.exists('login.landing.background_image.src')
              ? t('login.landing.background_image.src')
              : ''
          }
          className={clsx('login-landing-background-image', styles.image)}
        />
      </div>
      <div className={clsx('login-landing-inner-container', styles.innerContainer)}>
        <Label
          className={clsx('login-landing-welcome-text', styles.welcome)}
          text={t('login.landing.welcome_back_text')}
        />
        {!oauthOnly && (
          <>
            <Input
              className={clsx(styles.input, 'login-landing-input', errorText && 'error')}
              value={inputValue}
              label={label}
              placeholder={placeholder}
              leftText={showCountryCode && countryCode}
              helperText={errorText && t(errorText)}
              onChange={(value) => presenter.onInputChange(value)}
              onLeftClick={() => presenter.onCountryCodeClick()}
              disableLeft={disableCountryPicker}
              type={type}
              disabled={loading}
            />
            <Button
              className={clsx('login-landing-button', styles.button)}
              text={loading ? t('login.landing.loading_text') : t('login.landing.button_text')}
              disabled={loading}
              onClick={() => presenter.onNextClick()}
            />
          </>
        )}
        {showFacebook && (
          <FacebookButton
            className={clsx('login-landing-facebook', styles.facebook)}
            text={t('login.landing.facebook')}
            disabled={loading}
            onClick={() => presenter.onFacebookClick()}
          />
        )}
        {showGoogle && (
          <GoogleButton
            className={clsx('login-landing-google', styles.google)}
            text={t('login.landing.google')}
            disabled={loading}
            onClick={() => presenter.onGoogleClick()}
          />
        )}
        {showOutsideOauth && (
          <OutsideButton
            className={clsx('login-landing-outside', styles.outsideOauth)}
            text={t('login.landing.outside_oauth')}
            disabled={loading}
            onClick={() => presenter.onOutsideClick()}
          />
        )}
        <div className={clsx('login-landing-footer-space', styles.footerSpace)} />
        <Label
          className={clsx('login-landing-footer', styles.footer)}
          text={t('login.landing.footer')}
        />
      </div>
    </div>
  );
}

export default withTranslation()(View);
